export function isDateLessOrEqualThanToday(inputDate: string): boolean {
  const inputDateObj = new Date(inputDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return inputDateObj <= today;
}
